<div class="row align-items-center">
  <div class="col-12 col-lg-7">
    <div class="d-flex justify-content-start align-items-center">
      <div class="pr-3">
        <img
          class="mw60"
          loading="lazy"
          src="assets/images/msg-icon.png"
          alt="Icon"
        />
      </div>
      <div class="_nTypo">
        <h3>{{ "NEWSLETTER" | translate }}</h3>
        <span
          >{{
            "Join our Pantheian Community! Be connected and get periodic updates"
              | translate
          }}.</span
        >
      </div>
    </div>
  </div>
  <div class="col-12 col-lg-5">
    <app-newsletter-search></app-newsletter-search>
  </div>
</div>
